export const getBrandRewardsPayloadSchema = {
    type: 'object',
    properties: {
        limit: { type: 'integer' },
        section: { type: 'string' },
        brandId: { type: 'string' },
        filter: {
            type: 'object',
            properties: {
                freeToReserve: { type: 'boolean' },
            },
        },
    },
    required: [],
    additionalProperties: false,
};
